import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { isReportsV2Enabled } from "../../utils/reportsV2Flag";
import ReportsPage from "./ReportsPage";
import ReportDetailPage from "./ReportDetailPage";
import ReportsShell from "./shell/ReportsShell";
import ReportsIndexPage from "./shell/ReportsIndexPage";
import ReportInstancePage from "./shell/ReportInstancePage";

/**
 * Nested routes under /admin/reports/* (mounted in App.js behind
 * PermissionGate section="reports").
 *
 * - REACT_APP_REPORTS_V2 off (default): today's list page + per-report detail
 *   page, unchanged.
 * - On: the Reports & Summaries shell is a layout route, so its sidebar stays
 *   mounted while the <Outlet> swaps reports.
 *
 * The flag is read at render time (salesTabFlag pattern) so tests can flip it.
 */
export default function ReportsRoutes() {
  if (isReportsV2Enabled()) {
    return (
      <Routes>
        <Route element={<ReportsShell />}>
          <Route index element={<ReportsIndexPage />} />
          <Route path=":reportId" element={<ReportInstancePage />} />
        </Route>
        <Route path="*" element={<Navigate to="/admin/reports" replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route index element={<ReportsPage />} />
      <Route path=":reportId" element={<ReportDetailPage />} />
      {/* Deeper paths fell through to the admin catch-all before the nested
          mount; keep that behaviour. */}
      <Route path="*" element={<Navigate to="/admin/calendar" replace />} />
    </Routes>
  );
}
